<template>
  <div v-viewer="options" class="gallery">
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        button: false,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: true,
        rotatable: false,
        scalable: true,
        transition: true,
        fullscreen: true,
      },
    }
  },

  methods: {
    handleInit(viewer) {
      this.$viewer = viewer
      this.$viewer.view(this.index)
    },
  },
}
</script>

<style lang="scss">
.viewer-backdrop {
  background-color: rgba(12, 36, 63, 0.6);
}
</style>

<style lang="scss" scoped>
.gallery {
  width: 100%;
  height: 100%;
}
</style>
